// Static config only - dynamic catalog data now comes from backend.

export const STORE_INFO = {
  brandName: 'Fitness Pro Nutrition',
  phone: '(647) 327-0304',
  phoneRaw: '6473270304',
  email: 'fitnesspronutrition@hotmail.com',
  address: '3 Taylor Court, Bolton, ON',
  hours: 'Mon - Sun: 9:00am - 9:00pm',
  tagline: "Canada's Premier Supplement Store",
  domain: 'www.fitnesspronutrition.com',
  freeShipping: 90,
};

export const HERO_SLIDES = [
  { id: 1, image: 'https://wp.naturallyfit.ca/wp-content/uploads/Alani-Slider-1-66.png', title: 'Alani Nu', subtitle: 'Shop the latest flavours', brand: 'alani-nu' },
  { id: 2, image: 'https://wp.naturallyfit.ca/wp-content/uploads/Mammoth-Slider-1.png', title: 'Mammoth Supplements', subtitle: 'Built for the grind', brand: 'mammoth' },
  { id: 3, image: 'https://wp.naturallyfit.ca/wp-content/uploads/Believe-Slider-1.png', title: 'Believe Supplements', subtitle: 'Believe in better', brand: 'believe' },
  { id: 4, image: 'https://wp.naturallyfit.ca/wp-content/uploads/VNDL-Slider-1-83.png', title: 'VNDL Project', subtitle: 'Elevate your routine', brand: 'vndl-project' },
  { id: 5, image: 'https://wp.naturallyfit.ca/wp-content/uploads/Batch-27-Slider-2.png', title: 'Batch 27', subtitle: 'Limited edition drops', brand: 'batch-27' },
  { id: 6, image: 'https://wp.naturallyfit.ca/wp-content/uploads/Energy-Pouches-1-73.jpg', title: 'Energy Pouches', subtitle: 'Power on the go', brand: 'energy-pouches' },
];

export const PROMO_BANNERS = [
  { id: 1, image: 'https://wp.naturallyfit.ca/wp-content/uploads/NF_3_for_99-2026.png', alt: '3 for $99' },
  { id: 2, image: 'https://wp.naturallyfit.ca/wp-content/uploads/shipping-2.png', alt: '10% Banner' },
  { id: 3, image: 'https://wp.naturallyfit.ca/wp-content/uploads/shipping.png', alt: 'Free Hoodie' },
];

export const FEATURED_BANNER = {
  image: 'https://wp.naturallyfit.ca/wp-content/uploads/BEST-CREATINE-PRICES-1.png',
  alt: 'Best Creatine Prices',
};

export const NAV_LINKS = [
  { label: 'Shop', path: '/shop' },
  { label: 'Protein', path: '/shop?category=protein' },
  { label: 'Pre-Workout', path: '/shop?category=pre-workout' },
  { label: 'Recovery', path: '/shop?category=recovery' },
  { label: 'Brands', path: '/brands' },
  { label: 'Contact', path: '/contact' },
];
